import { z } from 'zod';
import { assignmentSchema, issuanceFormSchema } from './issuance.js';
import { conditionSchema } from './catalog.js';
/**
 * The platoon store (owner, 2026-09-13, story 30). A platoon sergeant signs
 * gear from the company store like any soldier, then distributes it to the
 * platoon's soldiers, who sign a form against the sergeant; they return it
 * to the sergeant, and the sergeant returns it to the company store.
 *
 * A distribution creates ordinary issuance forms — one per soldier, pending
 * that soldier's own signature — whose lines are carved out of the
 * sergeant's active assignments instead of stock. Nothing moves in
 * `stockLevels`; a serialized unit's holder changes when the soldier signs.
 * §3.2 stands: nobody approves, nobody signs for anyone.
 */
export const MAX_DISTRIBUTION_SOLDIERS = 60;
export const distributeLineSchema = z.object({
    /** One of the caller's own active assignments. */
    assignmentId: z.string().min(1),
    /** Per soldier. A serialized holding is always 1 and can go to one soldier only. */
    quantity: z.number().int().min(1).default(1),
    condition: conditionSchema.default('good'),
    notes: z.string().trim().max(500).nullable().default(null),
});
export const distributeRequestSchema = z.object({
    soldierUids: z.array(z.string().min(1)).min(1).max(MAX_DISTRIBUTION_SOLDIERS),
    lines: z.array(distributeLineSchema).min(1).max(50),
    dueDate: z.string().datetime().nullable().default(null),
});
export const distributeResponseSchema = z.object({ forms: z.array(issuanceFormSchema) });
/**
 * GET /api/distribution/holdings — the caller's platoon store: their own
 * active holdings (with what is out), and every open assignment carved
 * out of them, with the soldiers' names.
 */
export const holdingsResponseSchema = z.object({
    holdings: z.array(assignmentSchema),
    distributed: z.array(assignmentSchema),
    soldiers: z.array(z.object({ uid: z.string(), name: z.string(), unitName: z.string().nullable() })),
});
//# sourceMappingURL=distribution.js.map